import React from "react";
import { useParams } from "react-router-dom";
import DataAndMap from "../../../../components/SiteMap/DataAndMap";
import EditStateProvider from "../../../../components/SiteMap/contexts/EditStateContext";
import PaywallProvider from "../../../../components/SiteMap/contexts/PaywallContext";

const SiteMapIndex = () => {
  const { jobId } = useParams<{ jobId: string }>();
  return (
    <PaywallProvider jobId={jobId}>
      <EditStateProvider>
        <DataAndMap disableUi={false} />
      </EditStateProvider>
    </PaywallProvider>
  );
};

export default SiteMapIndex;
